import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { HoleInOneClaim } from '@/api/holeInOneClaim/holeInOneClaim.types';
import claimsIcon from '@/assets/claimsIcon.png';
import CustomEntityTable, {
  Column,
} from '@/components/controls/CustomEntityTable.tsx';
import Pagination from '@/components/layout/Pagination.tsx';
import { useHoleInOneClaims } from '@/hooks/useHoleInOneClaims.ts';
import { transformUnixToDateWithFormat } from '@/utils/dateUtil.ts';
import { capitalizeText } from '@/utils/valueFormatter.ts';

const holeInOneClaimColumns: Column<HoleInOneClaim>[] = [
  {
    key: 'submittedAtUnix',
    label: 'Time of Submission',
    sortable: true,
    width: 40,
    formattingFunc: transformUnixToDateWithFormat,
  },
  {
    key: 'status',
    label: 'Status',
    sortable: false,
    width: 30,
    formattingFunc: capitalizeText,
  },
  {
    key: 'submittedBy',
    label: 'Golfer Name',
    sortable: false,
    width: 30,
  },
];

const ClaimsDashboard: FC = () => {
  const {
    holeInOneClaimsCount,
    holeInOneClaims,
    isFetchingAll,
    fetchHoleInOneClaimDetails,
    pageSize,
    currentPage,
    setCurrentPage,
  } = useHoleInOneClaims();

  const navigate = useNavigate();

  const handleView = (claim: HoleInOneClaim): void => {
    fetchHoleInOneClaimDetails(claim.id).then(() => {
      navigate('/claim-details');
    });
  };

  return (
    <>
      <CustomEntityTable
        columns={holeInOneClaimColumns}
        data={holeInOneClaims}
        totalData={holeInOneClaimsCount}
        iconName={claimsIcon}
        isLoading={isFetchingAll}
        onView={handleView}
        title="Claims"
      />
      <Pagination
        totalItems={holeInOneClaimsCount}
        pageSize={pageSize}
        currentPage={currentPage}
        goToPage={setCurrentPage}
      />
    </>
  );
};

export default ClaimsDashboard;
